import {useEffect, useState} from "react";
import useLoading from "../../_lib/hooks/useLoading";
import {Loading} from "../Loading";
import ApiConta, {DataAcessMode} from "../../_api/ApiConta";
import {UserInfo} from "../../_lib/models/UserInfo";
import {encurtarNome} from "../../_util/StringUtil";

export default function ProfilePreview() {
    const [loading,, stopLoading] = useLoading(true),
        [userInfo, setUserInfo] = useState<UserInfo>(null);

    async function load() {
        const {data: userInfo} = await ApiConta.info(DataAcessMode.BASIC);
        setUserInfo(userInfo);
        stopLoading();
    }

    useEffect(() => {
        load().then(() => null);
    }, []);

    if (loading)
        return <Loading className="mb-2"/>;
    return <>
        <div className="-img">
            <img alt="foto de perfil" src={`data:image/png;base64, ${userInfo.foto}`} />
        </div>
        <div className="-text">
            <p className="mb-0">{encurtarNome(userInfo.nome)}</p>
            <p className="mb-0">{userInfo.matricula}</p>
        </div>
    </>
}